<template>
    <v-dialog v-model="dialog" width="350px">
        <v-card class="card-dialog">
            <div class="py-3 text-center">
                <div class="title-reason">
                    {{ $t('common.select_reason') }}
                </div>
                <v-row no-gutters class="my-3 px-3">
                    <v-col
                        v-for="reason in reasonsOptions" :key="reason.value"
                        cols="4" @click="currentReason = reason.value" v-ripple
                        :class="['text-truncate text-reason pointer', {'reason-text-active': isActiveReason(reason.value)}]"
                    >
                        <v-icon :class="[{'reason-icon-active': isActiveReason(reason.value)}]" color="#000000"
                                v-text="reason.icon"/>
                        {{ reason.name }}
                    </v-col>
                </v-row>
                <div class="title-picker">
                    {{ $t('common.select_days_lock') }}
                </div>
                <v-date-picker
                    v-model="dates"
                    no-title
                    locale="es"
                    first-day-of-week="1"
                    :show-current="false"
                    multiple
                    :weekday-format="getDayString"
                    class="container-date-picker"
                    color="#CCFF99"
                />
                <v-btn class="b-primary" depressed @click="lockDays" :loading="loading">
                    {{ $t('common.save_changes') }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import {db} from "@/utils/Firebase";

export default {
    name: "LockDaysDialog",
    props: {
        student: {
            type: Object,
            default: null,
        },
        currentLockDays: {
            type: Array,
            default: null,
        },
    },
    data(vm) {
        return {
            dialog: false,
            loading: false,
            days: [
                vm.$t('days.short_monday'),
                vm.$t('days.short_tuesday'),
                vm.$t('days.short_wednesday'),
                vm.$t('days.short_thursday'),
                vm.$t('days.short_friday'),
                vm.$t('days.short_saturday'),
                vm.$t('days.short_sunday'),
            ],
            reasonsOptions: [
                {name: vm.$t('common.injury'), value: 'injury', icon: '$injury'},
                {name: vm.$t('common.vacations'), value: 'vacations', icon: '$vacations'},
                {name: vm.$t('common.other'), value: 'other', icon: '$injury'},
            ],
            currentReason: null,
            dates: [],
        }
    },
    methods: {
        show(dates) {
            const vm = this
            vm.dates = [...dates]
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.dates = []
            vm.currentReason = null
        },
        getDayString(date) {
            const vm = this
            return vm.days[vm.$moment(date).weekday()]
        },
        isActiveReason(reason) {
            const vm = this
            return vm.currentReason === reason
        },
        async lockDays() {
            const vm = this
            if (!vm.currentReason || vm.dates.length === 0 || !vm.student) return vm.toast(vm.$t('common.fields_incomplete'), 'error')

            vm.loading = true
            let currentLockDays = vm.currentLockDays.map(day => (day.date))
            let dates = vm.dates.filter(date => !currentLockDays.includes(date))

            for(let date of dates) {
                await db.collection('lockDays').add({
                    coachId: vm.currentUser.uid,
                    studentId: vm.student.objectID,
                    reason: vm.currentReason,
                    date: date,
                })
            }

            vm.loading = false
            vm.toast(vm.$t('common.lock_days_successful'))
            vm.hide()
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>

.card-dialog {
    background: #FFFFFF;
    border-radius: 8px;
}

.title-reason {
    font-weight: 300;
    font-size: 18px;
    line-height: 12px;
    letter-spacing: -0.05em;
    color: #03342C;
    margin: 12px 0;
}

.text-reason {
    font-weight: 300;
    font-size: 14px;
    line-height: 12px;
    letter-spacing: -0.05em;
    color: #03342C;
    border-radius: 8px;
}

.reason-text-active {
    font-weight: 600;
}

.reason-icon-active {
    background-color: #CCFF99;
    border-radius: 50%;
}

.title-picker {
    border-top: 1px solid #D9D9D9;
    font-weight: 300;
    font-size: 16px;
    line-height: 12px;
    letter-spacing: -0.05em;
    color: #03342C;
    padding-top: 12px;
    padding-bottom: 2px;
    margin-left: 29px;
    margin-right: 29px;
}

::v-deep .v-date-picker-header {
    display: none
}

::v-deep thead > tr > th {
    font-weight: 400 !important;
    font-size: 13px !important;
    line-height: 13px !important;
    color: #99CC00 !important;
}

::v-deep tbody > tr > td .v-btn--active {
    font-weight: 300 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    color: #333333 !important;
    border-radius: 0;
    opacity: 1 !important;
    width: 100%;
}

::v-deep tbody > tr > td > button:hover,
::v-deep tbody > tr > td > button:focus,
::v-deep tbody > tr > td > button:before {
    border-radius: 0;
    width: 100%;
}

::v-deep table {
    border-spacing: 0 !important;
    border-collapse: collapse !important;
}

::v-deep td,
::v-deep th {
    padding: 0 !important;
}

::v-deep .v-btn--active > .v-btn__content {
    font-weight: 800 !important;
}

::v-deep .v-btn--active:before {
    opacity: 0 !important;
}

::v-deep .v-date-picker-table {
    height: 100%;
}

.container-date-picker {
    border-bottom: 1px solid #D9D9D9;
    padding: 12px 0;
    margin-bottom: 12px;
}

</style>